module.exports = __webpack_public_path__ + "img/agriculture-careers.f6ba8c86.jpg";